import PropTypes from 'prop-types';
import { IconButton, Tooltip, makeStyles } from '@material-ui/core';
import { YoutubeSearchedFor, ZoomIn, ZoomOut } from '@material-ui/icons';
import { Panel, useOnViewportChange, useReactFlow } from 'reactflow';

import { usePathChartTableViewports } from './ChartTableViewportsContext';

const useStyles = makeStyles((theme) => ({
    controlWrapper: {
        backgroundColor: theme.palette.background.paper,
        borderRadius: '8px',
        margin: 0,
        padding: '8px 16px',
        display: 'flex',
        gap: '16px',
    },
    iconButton: {
        width: '40px',
        height: '40px',

        '& .MuiSvgIcon-root': {
            width: '24px',
        },
    },
}));

export function ChartControls({ viewportKey }) {
    const viewports = usePathChartTableViewports();
    useOnViewportChange({
        onChange: (viewport) => {
            if (viewports) viewports.set(viewportKey, viewport);
        },
    });
    const { zoomIn, zoomOut, fitView } = useReactFlow();
    const styles = useStyles();

    return (
        <Panel className={styles.controlWrapper} position="bottom-left">
            <Tooltip title="Zoom in">
                <IconButton className={styles.iconButton} onClick={() => zoomIn()}>
                    <ZoomIn />
                </IconButton>
            </Tooltip>
            <Tooltip title="Zoom out">
                <IconButton className={styles.iconButton} onClick={() => zoomOut()}>
                    <ZoomOut />
                </IconButton>
            </Tooltip>
            <Tooltip title="Reset zoom">
                <IconButton className={styles.iconButton} onClick={() => fitView()}>
                    <YoutubeSearchedFor />
                </IconButton>
            </Tooltip>
        </Panel>
    );
}

ChartControls.propTypes = {
    viewportKey: PropTypes.string,
};

ChartControls.defaultProps = {
    viewportKey: null,
};
